
export default class IrrigationWorks {
  // 获取中标项目
  static getWindList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/listByDatasourceId/oaFormWinBidding', 'post', data, axiosOption, httpOption);
  }

  static getList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/listByDatasourceId/oaFormIrrigationWorkstest', 'post', data, axiosOption, httpOption);
  }
  
  static createdIrrigationWorks (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/addDatasource/oaFormIrrigationWorkstest', 'post', data, axiosOption, httpOption);
  }

  static updateIrrigationWorks (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/updateDatasource/oaFormIrrigationWorkstest', 'post', data, axiosOption, httpOption);
  }
  
  static deleteIrrigationWorks (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/deleteDatasource/oaFormIrrigationWorkstest', 'post', data, axiosOption, httpOption);
  }
}
